const breadcrumbUrlContainsPathname = (pathname: string) => {
  const cleanedPathname = pathname.replace(/\/$/, '');

  return window.location.pathname.includes(cleanedPathname);
};

export { breadcrumbUrlContainsPathname };
